import axios from 'axios'

const BASE = (process.env.REACT_APP_API_BASEURL || '').replace(/\/+$/, '')

export const requiresReauthentication = (error) => ['auth/user-token-expired', 'auth/invalid-user-token', 'auth/user-disabled', 'auth/id-token-revoked'].includes(error.code) || error.response?.status === 401

export async function fetchUserProfile(token, signal) {
  const response = await axios.get(`${BASE}/users/me`, {
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
    timeout: 20000, signal,
  })
  if (!response.data?.profile || !Array.isArray(response.data.memberships)) {
    throw new Error('No se pudo cargar tu perfil.')
  }
  return response.data
}
